import './Loader.css'

const Loader = () => {
  return (
    <div className='loader-container'>
      <h2>Loading...</h2>
      <div className="loader"></div>
    </div>
  )
}

export default Loader;
